<div class="grow-list-container">
    <mat-toolbar class="grow-toolbar px-0" fxLayout="row" fxLayoutAlign="space-between center" fxHide.gt-sm>
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <h2>{{ 'ENGAGE.TITLE' | translate }}</h2>
        </div>
    </mat-toolbar>
    <div class="grow-cards-container">
        <div class="grow-card mb-8 p-20 pointer" *ngFor="let engageCard of engageCards" [ngClass]="engageCard.cls" [routerLink]="engageCard.url">
            <div class="experience-card-image-container mr-24">
                <div class="experience-card-image" fxLayoutAlign="center center">
                    <mat-icon [svgIcon]="engageCard.icon"></mat-icon>
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-between flex-start">
                <div fxLayout="column">
                    <h2 class="text-lg font-medium mt-0 mb-4">{{ engageCard.title | translate }}</h2>
                    <p class="my-0">{{ engageCard.text | translate }}</p>
                </div>
                <a fxLayout="row" fxLayoutAlign="start center">{{ engageCard.link | translate }}<mat-icon>arrow_right_alt</mat-icon> </a>
            </div>
        </div>
    </div>
</div>
